export default __webpack_public_path__ + "static/media/unknown.2e77d7cf.png";